import axios from '../request/http.js'
import { handleGetRequestParams } from '../common/js/utils.js'

class FinanceApproval {
  /* 待审批列表 */
  static financeApprovalList(data) {
    let url = `/zzd/api/back/admin/examine/reimbursement/page?`
    url += handleGetRequestParams(data)
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 已审批列表 */
  static financeFinishApprovalList(data) {
    let url = `/zzd/api/back/admin/examine/list/approved?`
    url += handleGetRequestParams(data)
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 审批(同意/驳回) */
  static financeApproval(data) {
    const url = `/zzd/api/back/admin/examine/agree`
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 获取签名图 */
  static getSignImg() {
    const url = `/zzd/api/back/admin/examine/user/sign`
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 补齐资料 */
  static postSupplementData(data) {
    const url = `/zzd/api/back/admin/examine/supplement/data`
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 财务列表 */
  static financeList(data) {
    let url = `/zzd/api/back/admin/examine/transfer/user/list?`
    url += handleGetRequestParams(data)
    return axios.get(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 移交审核人 */
  static postTransferReviewer(data) {
    const url = `/zzd/api/back/admin/examine/transfer`
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 经费结算单详情 */
  static getFundDetails(id) {
    const url = `/zzd/api/back/admin/examine/reimbursement/detail/${id}`
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 经费结算单关联的资产列表 */
  static getFundAssetsDetails(id) {
    const url = `/zzd/api/back/admin/examine/reimbursement/detail/property/list/${id}`
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 差旅报销单详情 */
  static getBusinessDetails(id) {
    const url = `/zzd/api/back/admin/examine/business/reimbursement/detail/${id}`
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 补齐资料图片集合 */
  static getSupplementDataImgList(data) {
    let url = `/zzd/api/back/admin/examine/list/supplement/data?`
    url += handleGetRequestParams(data)
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 上会资料图片集合 */
  static getSubDataImgList(data) {
    let url = `/zzd/api/back/admin/examine/list/sub/data?`
    url += handleGetRequestParams(data)
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 核准单据数量 */
  static postModBillNums(data) {
    const url = `/zzd/api/back/admin/examine/reimbursement/approved/billNum`
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 核准金额 */
  static postModApprovedAmount(data) {
    const url = `/zzd/api/back/admin/examine/reimbursement/approved/amount`
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }

  /* 开支内容 */
  static postModApprovedContent(data) {
    const url = `/zzd/api/back/admin/examine/reimbursement/approved/content`
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }

  /* 修改出差天数 */
  static postModDays(data) {
    const url = `/zzd/api/back/admin/examine/update/business/days`
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 修改出行方式 */
  static postModTravelMode(data) {
    const url = `/zzd/api/back/admin/examine/business/reimbursement/update/travel/mode`
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 修改同行人数 */
  static postModPeopleNum(data) {
    const url = `/zzd/api/back/admin/examine/business/reimbursement/update/people/num`
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 修改到达地点 */
  static postModAddress(data) {
    const url = `/zzd/api/back/admin/examine/business/reimbursement/update/city`
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 修改出差理由 */
  static postModReasonsForBusinessTrip(data) {
    const url = `/zzd/api/back/admin/examine/business/reimbursement/update/reasons/for/business/trip`
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 修改出差日期 */
  static postModDate(data) {
    const url = `/zzd/api/back/admin/examine/business/reimbursement/update/begin/end/time`
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 费用单详情 */
  static postBillDetails(data) {
    let url = `/zzd/api/back/admin/examine/bill/list?`
    url += handleGetRequestParams(data)
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 财务审批人查看打印预览 */
  static printPreview(type, orderId) {
    let url = `/zzd/api/back/pdf/download?type=${type}&orderId=${orderId}`
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 日期采购单列表 */
  static getPurchaseList(billId, billType) {
    let url = `/zzd/api/back/admin/examine/list/purchase?billId=${billId}&billType=${billType}`
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 工薪单列表 */
  static getSalaryBillList(orderId) {
    let url = `/zzd/api/back/admin/examine/list/payroll?orderId=${orderId}`
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
}

export default FinanceApproval
